import { useMandatorContext, MandatorType } from "@rentablo/theming";

export interface VisibilityRule {
  hideFor?: MandatorType[];
  showFor?: MandatorType[];
}

export function useMandatorVisibility(rule: VisibilityRule): boolean {
  const { mandatorSlug } = useMandatorContext();

  if (rule.hideFor && rule.hideFor.includes(mandatorSlug)) {
    return false;
  }

  if (rule.showFor?.length) {
    return rule.showFor.includes(mandatorSlug);
  }

  return true;
}
